import { useEffect } from "react"
import types from "prop-types"

const NO_DATA = {}

const NoDataToDefine = ({ actionIndex, changeActionData }) => {
  useEffect(() => {
    changeActionData(actionIndex)(NO_DATA)
  }, [actionIndex, changeActionData])

  return null
}

NoDataToDefine.propTypes = {
  actionIndex: types.number.isRequired,
  changeActionData: types.func.isRequired,
}

export default NoDataToDefine
